<template>
  <div
    v-if="visible"
    class="alert"
    :class="alertClass"
    role="alert">
    <span class="alert-message">{{ message }}</span>
    <button
      type="button"
      class="alert-close"
      @click="handleClose"
      aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'warning',
      validator: (value) => ['warning', 'danger', 'success'].includes(value),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    alertClass() {
      return 'alert-violet';
    },
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.alert {
  padding: 12px 16px;
  margin-bottom: 16px;
  border-radius: 6px;
  border: 2px solid;
  font-size: 14px;
  line-height: 1.4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.alert-message {
  flex: 1;
  margin: 0;
  font-weight: 500;
}

.alert-close {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  min-width: 28px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  transition: background-color 0.2s ease;
  color: #482882 !important;
  flex-shrink: 0;
}

.alert-close span {
  color: #482882 !important;
}

.alert-close:hover {
  background-color: rgba(72, 40, 130, 0.1);
}

/* Thème violet unique pour toutes les alertes */
.alert-violet {
  border-color: #482882;
  background-color: #E8DAFF;
  color: #482882;
}
</style>
